import React from 'react';
import CreatorsListPage from '../../features/apps/components/CreatorsListPage';

const CreatorsPageRoute = () => {
  return <CreatorsListPage fromLanding={false} />;
};

export default CreatorsPageRoute;
